import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_STUDY_LEVELS, 
    ADD_NEW_STUDY_LEVEL, 
    UPDATE_STUDY_LEVEL, 
    DELETE_STUDY_LEVEL 
} from "./actionTypes";
import {
    getStudyLevelsSuccess,
    getStudyLevelsFail,
    addStudyLevelSuccess,
    addStudyLevelFail,
    updateStudyLevelSuccess,
    updateStudyLevelFail,
    deleteStudyLevelSuccess,
    deleteStudyLevelFail,
   
} from "./actions"

import {
    getStudyLevels,
    addNewStudyLevel,
    updateStudyLevel,
    deleteStudyLevel,
   
} from "helpers/study-levels/study_levels_backend_helper";
import { toast } from "react-toastify";

function* fetchStudyLevels() {
    try {
        const response = yield call(getStudyLevels)

        

        yield put(getStudyLevelsSuccess(response))
    } catch (error) {
        yield put(getStudyLevelsFail(error))
    }
}

function* onAddNewStudyLevel({ payload }) {
    try {

        
        const response = yield call(addNewStudyLevel, payload)

        console.log("RESPONSE:", response);
        yield put(addStudyLevelSuccess(response.studyLevel))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addStudyLevelFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateStudyLevel({ payload: data }) {
    try {
        const response = yield call(updateStudyLevel, data)
        yield put(updateStudyLevelSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateStudyLevelFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateStudyLevel({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateStudyLevel, payload)
        console.log("RESPONSE: ", response.studyLevel);
        yield put(updateStudyLevelSuccess(response.studyLevel))

        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateStudyLevelFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteStudyLevel({ payload: data }) {

    try {
        const response = yield call(deleteStudyLevel, data)
        yield put(deleteStudyLevelSuccess(response.studyLevelId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteStudyLevelFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* studyLevelSaga() {
    yield takeEvery(GET_STUDY_LEVELS, fetchStudyLevels)
    yield takeEvery(ADD_NEW_STUDY_LEVEL, onAddNewStudyLevel)
    yield takeEvery(UPDATE_STUDY_LEVEL, onUpdateStudyLevel)
    yield takeEvery(DELETE_STUDY_LEVEL, onDeleteStudyLevel)
}

export default studyLevelSaga;